import { getCallbackUserManager } from '@components/Auth/manager';
import { useEffect } from 'react';

export const useAuth0Logout = () => {
  const trySignOutAsync = async () => {
    const userManager = getCallbackUserManager();

    const user = await userManager.getUser();
    if (!user) {
      localStorage.clear();
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const iss = urlParams.get('iss');
    const sid = urlParams.get('sid');
    if (iss && userManager.settings.authority === iss && sid && user.profile.sid === sid) {
      await userManager.signoutRedirectCallback();
      await userManager.removeUser();
    }
  };

  useEffect(() => {
    trySignOutAsync();
  }, []);
};
